import React from "react";
import { useTranslation } from "react-i18next";

function PdfFormError({ name, required, description, focusFieldCb }) {
  const { t } = useTranslation();

  return (
    <div key={name} className={"is-clickable content is-size-7"} onClick={focusFieldCb}>
      <span className="subtitle is-size-6 has-text-weight-bold is-italic">{name}</span>
      <div className="mt-2">
        <div>
          {t("requests.submission.pdf.pdfFormErrorInfo.required")}:{" "}
          {required
            ? t("requests.submission.pdf.pdfFormErrorInfo.yes")
            : t("requests.submission.pdf.pdfFormErrorInfo.no")}
        </div>
        <div>
          {t("requests.submission.pdf.pdfFormErrorInfo.description")}: {description}
        </div>
      </div>
    </div>
  );
}

export default PdfFormError;
